__webpack_require__.p = "https://assets-01.periodica.press/241cf6f-19783340776/";